import { endpointPropTypes } from '@gef-ui/version-info-core/constants';
import useVersionInfo from '@gef-ui/version-info-core/hooks/useVersionInfo';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import VersionDisplay from '../VersionDisplay';
const VersionInfo = ({ versionElementId, screenId, screenName, parseFeResponse, parseBeResponse, skipBeOauth, beEndpointMappingArray, feEndpointMappingArray, screenIdElementId, screenIdTestId, screenNameTestId })=>{
    const { fe, be } = useVersionInfo({
        parseFeResponse,
        parseBeResponse,
        skipBeOauth,
        beEndpointMappingArray,
        feEndpointMappingArray
    });
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        columnSpacing: 4
    }, /*#__PURE__*/ React.createElement(Grid, {
        id: screenIdElementId
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            color: 'text.secondary'
        }
    }, /*#__PURE__*/ React.createElement("span", {
        "data-test-id": screenIdTestId
    }, screenId), screenId && screenName && ' – ', /*#__PURE__*/ React.createElement("span", {
        "data-test-id": screenNameTestId
    }, screenName))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        size: "grow",
        columnSpacing: 2,
        id: versionElementId,
        sx: {
            justifyContent: 'right'
        }
    }, /*#__PURE__*/ React.createElement(VersionDisplay, {
        fe: fe,
        be: be
    })));
};
VersionInfo.propTypes = {
    beEndpointMappingArray: endpointPropTypes,
    feEndpointMappingArray: endpointPropTypes,
    parseBeResponse: PropTypes.func,
    parseFeResponse: PropTypes.func,
    screenId: PropTypes.string,
    screenIdElementId: PropTypes.string,
    screenIdTestId: PropTypes.string,
    screenName: PropTypes.string,
    screenNameTestId: PropTypes.string,
    skipBeOauth: PropTypes.bool,
    versionElementId: PropTypes.string
};
export default VersionInfo;
